import { IAvisEditableListFieldConfig } from "../../../types";
import { AvisEditableListHeaderValue } from "../../AvisEditableListHeaderValue";

interface IAvisEditableListHeaderCellProps<P extends object> {
  field: IAvisEditableListFieldConfig<P>;
  disabled: boolean | undefined;
}
export function AvisEditableListHeaderCell<P extends object>(
  props: Readonly<IAvisEditableListHeaderCellProps<P>>,
) {
  return (
    <th className={"avis-editable-list-header-cell"}>
      <AvisEditableListHeaderValue {...props} />
    </th>
  );
}
